import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

export default function LoaderModal({ show }) {
  return (
    <Modal show={show} size="sm" centered>
      <Modal.Body>
        <Row className="m-0 p-0">
          <Col className="text-center m-0 p-0">
            <Spinner animation="grow" variant="secondary" />
          </Col>
        </Row>
        <Row className="m-0 p-0">
          <Col className="text-center">Cargando...</Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
